import { useEffect, useState } from 'react';
import { fetchJson } from '../../../helpers/fetch.js';
import queryClient from '../../../../query_client.js';

import {
  project_resource_month_columns_path
} from '~/routes';

export function useMonths({ months: monthsProp, projectId }) {
  const [months, setMonths] = useState(monthsProp);

  useEffect(() => {
    setMonths(monthsProp);
  }, [monthsProp]);

  useEffect(() => {
    if (monthsProp) return;
    if (!projectId) return;

    const fetchPath = project_resource_month_columns_path({ project_id: projectId });

    queryClient
      .fetchQuery({
        queryKey: ['projectResourceMonthColumns', projectId],
        queryFn: () => fetchJson(fetchPath),
        staleTime: 30_000,
        keepPreviousData: true
      })
      .then(response => {
        const next = Array.isArray(response)
          ? response
          : [];
        setMonths(next);
      });
  }, [monthsProp, projectId]);

  return {
    months
  };
}
